import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.LXK2U27H.js";
import {
  ke,
  r as r2
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-secondary-menu-list/jb-secondary-menu-list.scss?inline
var jb_secondary_menu_list_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

*:focus-visible {
  outline-color: rgb(var(--theme-color-signal-blue, 0 37 255));
  outline-offset: 6px;
  outline-style: var(--focus-outline-style, auto);
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
}

jb-menu-item:focus {
  box-shadow: none;
  outline: none;
}

.secondary {
  font-size: 0;
  font-size: 0;
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--theme-row-small-margin, 6.68%));
  display: block;
  height: auto;
  margin-left: var(--theme-row-small-margin, 6.68%);
  margin-right: auto;
  margin-top: -11px;
  overflow: hidden;
  position: absolute;
  transition: opacity 0s 0s, transform 0s 0s, height 0s 0s;
  width: calc(100% - var(--theme-row-small-margin, 6.68%) * 2);
}
@media (min-width: 600px) and (max-width: 959px) {
  .secondary {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  .secondary {
    max-width: var(--theme-row-max-width, 1436px);
  }
  .secondary:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  .secondary {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}
@media (min-width: 600px) {
  .secondary {
    margin-left: 30vw;
    margin-top: -24px;
    transition: opacity 0.4s, max-height 0.4s ease-in-out;
    transition-delay: 0s, 0.6s;
    width: 40vw;
  }
}
@media (min-width: 1281px) {
  .secondary {
    margin-top: -11px;
  }
}
@media (min-width: 1281px) and (hover: hover) {
  .secondary {
    margin-left: 0;
  }
}
@media (hover: none) and (width >= 600px) {
  .secondary {
    transition: opacity 0s, transform 0s, height 0s;
    transition-delay: 0s, 0s, 0s, 0s;
  }
}
.secondary jb-menu-item {
  max-height: 100vh;
}
.secondary jb-menu-item:nth-child(1) {
  transition: opacity 0.5s ease-in-out 0s;
}
.secondary jb-menu-item:nth-child(2) {
  transition: opacity 0.5s ease-in-out 0.1s;
}
.secondary jb-menu-item:nth-child(3) {
  transition: opacity 0.5s ease-in-out 0.2s;
}
.secondary jb-menu-item:nth-child(4) {
  transition: opacity 0.5s ease-in-out 0.3s;
}
.secondary jb-menu-item:nth-child(5) {
  transition: opacity 0.5s ease-in-out 0.4s;
}
.secondary jb-menu-item:nth-child(6) {
  transition: opacity 0.5s ease-in-out 0.5s;
}
.secondary jb-menu-item:nth-child(7) {
  transition: opacity 0.5s ease-in-out 0.6s;
}
.secondary jb-menu-item:nth-child(8) {
  transition: opacity 0.5s ease-in-out 0.7s;
}
.secondary jb-menu-item:nth-child(9) {
  transition: opacity 0.5s ease-in-out 0.8s;
}
.secondary jb-menu-item:nth-child(10) {
  transition: opacity 0.5s ease-in-out 0.9s;
}
.secondary jb-menu-item:nth-child(11) {
  transition: opacity 0.5s ease-in-out 1s;
}
.secondary jb-menu-item:nth-child(12) {
  transition: opacity 0.5s ease-in-out 1.1s;
}
.secondary jb-menu-item:nth-child(13) {
  transition: opacity 0.5s ease-in-out 1.2s;
}
.secondary jb-menu-item:nth-child(14) {
  transition: opacity 0.5s ease-in-out 1.3s;
}
.secondary jb-menu-item:nth-child(15) {
  transition: opacity 0.5s ease-in-out 1.4s;
}
.secondary jb-menu-item:nth-child(16) {
  transition: opacity 0.5s ease-in-out 1.5s;
}
.secondary jb-menu-item:nth-child(17) {
  transition: opacity 0.5s ease-in-out 1.6s;
}
.secondary jb-menu-item:nth-child(18) {
  transition: opacity 0.5s ease-in-out 1.7s;
}
.secondary jb-menu-item:nth-child(19) {
  transition: opacity 0.5s ease-in-out 1.8s;
}
.secondary jb-menu-item:nth-child(20) {
  transition: opacity 0.5s ease-in-out 1.9s;
}
.secondary jb-menu-item:nth-child(21) {
  transition: opacity 0.5s ease-in-out 2s;
}
.secondary jb-menu-item:nth-child(22) {
  transition: opacity 0.5s ease-in-out 2.1s;
}
.secondary jb-menu-item:nth-child(23) {
  transition: opacity 0.5s ease-in-out 2.2s;
}
.secondary jb-menu-item:nth-child(24) {
  transition: opacity 0.5s ease-in-out 2.3s;
}
.secondary jb-menu-item:nth-child(25) {
  transition: opacity 0.5s ease-in-out 2.4s;
}
.secondary jb-menu-item:nth-child(26) {
  transition: opacity 0.5s ease-in-out 2.5s;
}
.secondary jb-menu-item:nth-child(27) {
  transition: opacity 0.5s ease-in-out 2.6s;
}
.secondary jb-menu-item:nth-child(28) {
  transition: opacity 0.5s ease-in-out 2.7s;
}
.secondary jb-menu-item:nth-child(29) {
  transition: opacity 0.5s ease-in-out 2.8s;
}
.secondary jb-menu-item:nth-child(30) {
  transition: opacity 0.5s ease-in-out 2.9s;
}
.secondary jb-menu-item:nth-child(31) {
  transition: opacity 0.5s ease-in-out 3s;
}
.secondary jb-menu-item:nth-child(32) {
  transition: opacity 0.5s ease-in-out 3.1s;
}
.secondary jb-menu-item:nth-child(33) {
  transition: opacity 0.5s ease-in-out 3.2s;
}
.secondary jb-menu-item:nth-child(34) {
  transition: opacity 0.5s ease-in-out 3.3s;
}
.secondary jb-menu-item:nth-child(35) {
  transition: opacity 0.5s ease-in-out 3.4s;
}
.secondary jb-menu-item:nth-child(36) {
  transition: opacity 0.5s ease-in-out 3.5s;
}
.secondary jb-menu-item:nth-child(37) {
  transition: opacity 0.5s ease-in-out 3.6s;
}
.secondary jb-menu-item:nth-child(38) {
  transition: opacity 0.5s ease-in-out 3.7s;
}
.secondary jb-menu-item:nth-child(39) {
  transition: opacity 0.5s ease-in-out 3.8s;
}
.secondary jb-menu-item:nth-child(40) {
  transition: opacity 0.5s ease-in-out 3.9s;
}
.secondary jb-menu-item:nth-child(41) {
  transition: opacity 0.5s ease-in-out 4s;
}
.secondary jb-menu-item.hidden {
  max-height: 0;
  opacity: 0 !important;
  overflow: hidden;
  transition: opacity 0.5s ease-in-out, max-height 0s 0.5s;
  z-index: -1 !important;
}
.secondary jb-menu-item:first-of-type {
  --padding-top: 0;
}
@media (min-width: 600px) {
  .secondary jb-menu-item:first-of-type {
    margin-top: 20px;
  }
}
@media (min-width: 1281px) and (hover: hover) {
  .secondary jb-menu-item:first-of-type {
    --padding-top: 10px;
    margin-top: 0;
  }
}
.secondary jb-menu-item:last-of-type {
  margin-bottom: 90px;
}`;

// src/components/jb-secondary-menu-list/jb-secondary-menu-list.ts
var JbSecondaryMenuList = class extends Animatable(r2) {
  constructor() {
    super(...arguments);
    this.activeIndex = 0;
  }
  _clearFocusedStateOnAll() {
    this.renderRoot.querySelectorAll("jb-menu-item").forEach((item) => {
      item.classList.remove("focus");
      item.classList.remove("active");
    });
  }
  _focusFirstMenuItem() {
    const menuItemToSelect = this.renderRoot.querySelector("jb-menu-item:not(.hidden)");
    menuItemToSelect.focus();
  }
  _handleFocus(evt) {
    this._clearFocusedStateOnAll();
    if (this.activeIndex !== parseInt(evt.target.dataset.index, 10)) {
      this.activeIndex = parseInt(evt.target.dataset.index, 10);
    }
    evt.target.classList.add("focus");
    evt.target.classList.add("active");
  }
  _handleFocusOut() {
    document.querySelector("jb-menu").shadowRoot.querySelector("jb-button-back")?.focus();
  }
  _removeFocus(evt) {
    evt.target.classList.remove("focus");
    evt.target.classList.remove("active");
  }
  _renderMenuItem(item, indx) {
    return ke`<p>${item.text}</p>
      <jb-menu-item
        .link=${item.link}
        .submenu=${item.submenu}
        .tag=${item.tag}
        .text=${item.text}
        .type=${"secondary"}
        .notTabbable=${this.activeIndex !== indx}
        data-index=${indx}
        class="${Rt({
      hidden: true
    })}"
        @focus=${this._handleFocus}
        @focusout=${this._removeFocus}
      ></jb-menu-item>`;
  }
  render() {
    return ke`
      <ul
        class="secondary"
        @focus=${this._focusFirstMenuItem}
      >
        ${this.staticItem && ke`<jb-menu-item
          class="hidden"
          .link=${this.staticItem?.link}
          .text=${this.staticItem?.text}
          .type=${"secondary"}
        ></jb-menu-item>`}
        ${this.menuItems.map((item, indx) => this._renderMenuItem(item, indx))}
        <li
          class="last-item-focus-trap"
          @focusin=${this._handleFocusOut}
          tabindex="0"
        >
          &nbsp;
        </li>
      </ul>
    `;
  }
};
JbSecondaryMenuList.styles = r(jb_secondary_menu_list_default);
JbSecondaryMenuList.shadowRootOptions = { ...r2.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Number })
], JbSecondaryMenuList.prototype, "activeIndex", 2);
__decorateClass([
  n({ type: Array })
], JbSecondaryMenuList.prototype, "menuItems", 2);
__decorateClass([
  n({ type: Object })
], JbSecondaryMenuList.prototype, "staticItem", 2);
JbSecondaryMenuList = __decorateClass([
  customElement("jb-secondary-menu-list")
], JbSecondaryMenuList);

export {
  JbSecondaryMenuList
};
